import {get} from '@vueuse/core';
import {computed, type MaybeRef} from 'vue';
import {useLink, type RouterLinkProps} from 'vue-router';

/**
 * Composable to easily create required props for PrimeVue buttons which should be displayed as links
 */
export default function useButtonLink(to: MaybeRef<RouterLinkProps['to'] | null>) {
    const toComputed = computed(() => get(to) ?? '/');
    const {href, navigate} = useLink({to: toComputed});

    const isActive = computed(() => !!get(to));

    const route = computed(() => {
        if (!isActive.value) {
            return null;
        }
        return {href: href.value, navigate};
    });

    function onClick(event: Event) {
        if (isActive.value) {
            navigate();
            event.preventDefault();
        }
    }

    const as = computed(() => (isActive.value ? 'a' : undefined));

    return {route, onClick, as};
}
